import React from "react";
import { Row } from "react-bootstrap";
import CardBody from "./CardBody";
import CardHeader from "./CardHeader";

const Card = ({
  type,
  title,
  data,
  modal,
  modalLink,
  fetchLearningModuleData,
  sliceData = true,
}: {
  type: number;
  title: String;
  data: any;
  modal?: any;
  modalLink?: any;
  fetchLearningModuleData: any;
  sliceData?: boolean;
}) => {
  return (
    <>
      <Row
        className={
          type === 1 ? "bgwhite b_shadow p_all " : "shadowLRB rowBg p_all"
        }
      >
        <CardHeader title={title} modal={modal} />
        <CardBody
          data={data}
          linkTitle={modalLink}
          fetchLearningModuleData={fetchLearningModuleData}
          sliceData={sliceData}
        />
      </Row>
    </>
  );
};

export default Card;
